import React, { useMemo } from "react";
import zxcvbn from "zxcvbn";

interface PasswordStrengthBarProps {
  password: string;
  className?: string;
}

const strengthColors = [
  "#FF0000", // Very Weak
  "#ff6e6e", // Weak
  "#fec100", // Fair
  "#89BF89D1", // Good
  "#00fe00", // Strong
];

const strengthLabels = ["Very Weak", "Weak", "Fair", "Good", "Strong"];

export const PasswordStrengthBar: React.FC<PasswordStrengthBarProps> = ({
                                                                              password,
                                                                              className = "",
                                                                            }) => {
  const result = useMemo(() => zxcvbn(password || ""), [password]);
  const score = result.score; // 0–4
  const label = strengthLabels[score];
  const activeColor = strengthColors[score];

  const totalSegments = 5;

  return (
    <div className={`w-full ${className}`}>
      {/* Segmented bar */}
      <div className="flex gap-1 mt-1">
        {Array.from({ length: totalSegments }).map((_, i) => (
          <div
            key={i}
            className="h-0.5 flex-1 rounded-sm"
            style={{
              backgroundColor:
                password && i <= score ? activeColor : "rgba(100,100,100,0.3)",
            }}
          />
        ))}
      </div>

      {/* Label */}
      {password && (
        <div
          className="mt-0.5 text-xs text-center font-medium"
          style={{ color: activeColor }}
        >
          {label}
        </div>
      )}
    </div>
  );
};
